import { createAction, props } from '@ngrx/store';
import { Report } from '@apps/rept/domain/models/report';
import { ShortRecipient } from '@apps/rept/domain/models';

export const BackReptAddDefaultContractualReportsRequested = createAction(
    '[BACK-REPT] Back Rept Add Default Contractual Reports Requested',
    props<{ entityId: string, internalRecipients: string[], externalRecipients: ShortRecipient[] }>()
);
export const BackReptAddDefaultContractualReportsSucceeded = createAction(
    '[BACK-REPT] Back Rept Add Default Contractual Reports Succeeded',
    props<{ reports: Report[] }>()
);
export const BackReptAddDefaultContractualReportsFailed = createAction(
    '[BACK-REPT] Back Rept Add Default Contractual Reports Failed'
);